export default __webpack_public_path__ + "static/media/user_photo.ab3feeaf.svg";